import 'url-search-params-polyfill';
import { decodeBase64URLString } from '@thoughtspot/codec-util';
import _ from 'lodash';
import { BLINK_FLAGS, COMMON_FLAGS } from './flags.const';
export let FLAGS = { ...BLINK_FLAGS, ...COMMON_FLAGS };
export function containsV1inPath() {
    const href = window.location.href;
    return href.includes('/v1/');
}
export function getQueryParamsAndQueryString(queryParamsOptions = {
    includeSearch: true,
}) {
    let queryString = queryParamsOptions.includeSearch && window.location?.search
        ? window.location.search
        : '';
    if (queryParamsOptions.includeHash) {
        const splitHash = window.location?.hash.split('?');
        const hashQueryString = splitHash && splitHash.length > 1 ? splitHash[1] : '';
        queryString =
            queryString.length > 0
                ? queryString.concat('&', hashQueryString)
                : `?${hashQueryString}`;
    }
    if (queryParamsOptions.customQueryString) {
        const queryStringWithoutQuestionMark = queryParamsOptions.customQueryString.replace('?', '');
        queryString =
            queryString.length > 0
                ? queryString.concat(queryStringWithoutQuestionMark)
                : `?${queryStringWithoutQuestionMark}`;
    }
    const queryParams = new URLSearchParams(queryString);
    const queryParamsJSON = {};
    const queryParamsMultiValue = {};
    if (queryParams.has('base64UrlEncodedFlags')) {
        const flagDecodedString = decodeBase64URLString(queryParams.get('base64UrlEncodedFlags'));
        const decodedString = flagDecodedString.replace(/&quot;/g, '"');
        const cleanedUrl = decodedString.replace(/amp;/g, '');
        cleanedUrl.split('&').forEach(param => {
            const flag = param.split('=');
            if (flag.length === 2) {
                queryParams.append(decodeURIComponent(flag[0]), decodeURIComponent(flag[1].replace(/\+/g, '%20')));
            }
        });
        queryParams.delete('base64UrlEncodedFlags');
    }
    queryParams.forEach((value, key) => {
        queryParamsJSON[key] = value;
        if (!(key in queryParamsMultiValue))
            queryParamsMultiValue[key] = [];
        queryParamsMultiValue[key].push(value);
    });
    const queryParamsWithoutEncoding = queryString
        .replace('?', '')
        .split('&')
        .reduce((a, b) => {
        const [key, val] = b.split('=');
        a[key] = val;
        return a;
    }, {});
    return {
        queryParams: queryParamsJSON,
        queryString,
        queryParamsMultiValue,
        queryParamsWithoutEncoding,
    };
}
export function getEmbedSkipIds() {
    const queryParamsAndQueryString = getQueryParamsAndQueryString();
    if (queryParamsAndQueryString?.queryParams?.hideObjects) {
        return JSON.parse(queryParamsAndQueryString.queryParams.hideObjects);
    }
    return [];
}
export function convertToType(value, type) {
    switch (type) {
        case 'string':
            if (value === undefined || value === null) {
                return value;
            }
            return `${value}`;
        case 'number':
            return parseInt(value, 10);
        case 'boolean':
            if (value === 'true') {
                return true;
            }
            if (value === 'false') {
                return false;
            }
            if (_.isNull(value)) {
                return null;
            }
            return !!value;
        default:
            return null;
    }
}
function inferType(variable) {
    const jsType = typeof variable;
    if (jsType === 'string') {
        if (variable.toLowerCase() === 'true' ||
            variable.toLowerCase() === 'false') {
            return 'boolean';
        }
        if (/^[-+]?\d+$/.test(variable.trim())) {
            return 'number';
        }
    }
    return jsType;
}
export function getFlagsFromSimpleJSON(json = {}, override = false) {
    const flags = {};
    for (const flag in json) {
        if (!!override && FLAGS.hasOwnProperty(flag)) {
            flags[flag] = {
                ...FLAGS[flag],
                overideValue: convertToType(json[flag], FLAGS[flag].type),
            };
        }
        else {
            flags[flag] = {
                name: flag,
                description: '',
                defaultValue: convertToType(json[flag], inferType(json[flag])),
                type: inferType(json[flag]),
                isListed: false,
            };
        }
    }
    return flags;
}
export const initEnvFlags = (overideFlags) => {
    Object.assign(FLAGS, overideFlags);
};
let booted = false;
export const resetEnvFlags = () => {
    FLAGS = { ...BLINK_FLAGS };
    Object.assign(FLAGS, COMMON_FLAGS);
    booted = false;
};
export const markEnvFlagsBooted = () => {
    booted = true;
};
export const isEnvFlagsBooted = () => booted;
export const envFlags = {
    getValue: flagName => {
        if (!FLAGS.hasOwnProperty(flagName)) {
            return null;
        }
        if (FLAGS[flagName].overideValue !== undefined) {
            return FLAGS[flagName].overideValue;
        }
        return FLAGS[flagName].defaultValue;
    },
    setValue: (flagName, value) => {
        if (!FLAGS.hasOwnProperty(flagName)) {
            return;
        }
        FLAGS[flagName].overideValue = convertToType(value, FLAGS[flagName].type);
    },
    resetValue: flagName => {
        delete FLAGS[flagName].overideValue;
    },
};
//# sourceMappingURL=flags.js.map